import { User } from "@platform/types/platform.types";

export function normalizeUserData(user: User) {
  const {
    first_name,
    last_name,
    photo,
    resume,
    is_email_notifications_enabled,
    ...rest
  } = user;

  return {
    ...rest,
    firstName: first_name,
    lastName: last_name,
    isEmailNotificationsEnabled: is_email_notifications_enabled,
    photo: photo
      ? {
          file: photo,
          name: "",
          size: 0,
          type: "",
          original: null,
        }
      : undefined,
    cv: resume
      ? {
          file: resume,
          name: "",
          size: 0,
          type: "",
          original: null,
        }
      : undefined,
  };
}

export default normalizeUserData;
